var map = {
	"./sideBar/authority.png": "8cdb",
	"./sideBar/dealer.png": "9120",
	"./sideBar/device.png": "14b6",
	"./sideBar/distribution.png": "cafb",
	"./sideBar/help.png": "ee1d",
	"./sideBar/home.png": "f305",
	"./sideBar/log.png": "da46",
	"./sideBar/setting.png": "8efc",
	"./sideBar/storage.png": "58e9",
	"./sideBar/user.png": "1a4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eeda";